


























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Location } from 'vue-router';
import Icon from '@/components/Icon.vue';
import AuditTimeline from '@/components/audit/AuditTimeline.vue';
import idealName from '@/utils/ideal-name';
import capitalize from '@/utils/text';
import { AuditEntry, fetchQueueAuditLogs } from '@/api/audit';

@Component({ components: { Icon, AuditTimeline } })
export default class AuditDrawer extends Vue {
    @Prop(String) readonly name!: string;

    @Prop(Number) readonly customerId!: number;

    isOpen = false;

    isLoading = false;

    error = '';

    entries: AuditEntry[] = [];

    get queueOwnName(): string {
        const queue = this.$store.getters.getQueueByName(this.name);

        return queue?.metadata?.name || '';
    }

    get queueDisplayName(): string {
        return this.queueOwnName || capitalize(idealName(this.name));
    }

    get title(): string {
        return String(this.$t('audit_queue_title', { queue: this.queueDisplayName }));
    }

    // Only shown when the queue has a name of its own, so a queue without one does not repeat
    // its number under a title that already carries it.
    get queueExtension(): string {
        return this.queueOwnName === '' ? '' : idealName(this.name);
    }

    get generalAuditRoute(): Location {
        return { name: 'Audit', query: { queueName: this.name } };
    }

    open() {
        this.isOpen = true;
        this.load();
    }

    close() {
        this.isOpen = false;
    }

    async load() {
        this.isLoading = true;
        this.error = '';
        this.entries = [];

        try {
            this.entries = await fetchQueueAuditLogs({
                customerId: this.customerId,
                queueName: this.name,
            });
        } catch (err) {
            this.error = String(this.$t('audit_load_error'));
        } finally {
            this.isLoading = false;
        }
    }
}
